export const ProposalRoute = {
  PROPOSALS: '/proposals',
  PROPOSAL_CREATE: '/proposals/new',
  PROPOSAL_DETAILS: '/proposals/:id',
};

export const ProposalName = {
  PROPOSALS: 'proposals',
  PROPOSAL_CREATE: 'proposal-create',
  PROPOSAL_DETAILS: 'proposal-details',
};

export const ProposalStatus = {
  STATUS_DRAFT: 'Draft',
  STATUS_PENDING_APPROVAL: 'Pending Approval',
  STATUS_CLOSED_LOST: 'Closed-Lost',
  STATUS_APPROVED: 'Approved',
  STATUS_COMPLETED: 'Completed',
};

export const ProposalUpdateActions = {
  ACTION_SUBMIT: 'submit',
  ACTION_APPROVE: 'approve',
  ACTION_REJECT: 'reject',
  ACTION_CONVERT_TO_ORDER: 'convert_to_order',
};

export const ProposalSteps = {
  STEP_1: 'step1',
  STEP_2: 'step2',
  STEP_3: 'step3',
};

export const ProposalListColumns = {
  ACTIONS: 'actions',
  CLIENT: 'client',
  NAME: 'name',
  TOTAL_BUDGET: 'total_budget',
  START_DATE: 'start_date',
  SALESPERSON: 'salesperson',
  STATUS: 'status',
};

export const RequiredProposalFields = {
  NAME: 'name',
  CLIENT_ID: 'client_id',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  TOTAL_BUDGET: 'total_budget',
  OBJECTIVE: 'objective',
};

export const RequiredProductProposalFields = {
  NAME: 'name',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  TOTAL_BUDGET: 'total_budget',
  WHOLESALE_CPM: 'wholesale_cpm',
  MARKUP_PERCENT: 'markup_percent',
  PROPOSAL_RETAIL_CPM: 'proposal_retail_cpm',
};

export const REJECTION_REASON_LABELS = {
  budget_constraints: 'Budget Constraints',
  timeline_issue: "Timeline Doesn't Work",
  wrong_audience_target: 'Wrong Audience Targeting',
  client_changed_direction: 'Client Changed Direction',
  product_mix_not_suitable: 'Product Mix Not Suitable',
  other: 'Other',
};

export const COST_BASIS_BLOCKING_FIELDS = [
  'total_budget',
  'wholesale_cpm',
  'markup_percent',
  'proposal_retail_cpm',
];

export const ChannelClassification = {
  TRADITIONAL: 'traditional',
  DIGITAL: 'digital',
};

export const ChannelFields = {
  CLASSIFICATION: 'classification',
  CHANNEL_NAME: 'channel_name',
};
